import React from 'react';
import { Redirect } from 'react-router-dom';
import { BusinessRouterPaths } from '../../../page/Routes/RouterPaths';

const LegacyInventoryOrderReportRedirect: React.FC = () => (
    <Redirect to={BusinessRouterPaths.inventoryReplenishmentHub} />
);

export default LegacyInventoryOrderReportRedirect;
